import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet, useWindowDimensions} from 'react-native';

export default (props: ITheme) => {
  const width = useWindowDimensions().width;

  return StyleSheet.create({
    defaultContainerStyle: {
      flex: 1,
      backgroundColor: props.colors.transparentPrimary,
    },

    headerView: {
      flexGrow: 1,
      width: '100%',
      paddingLeft: 15,
      paddingRight: 15,
      paddingTop: 5,
    },

    calendarStyle: {
      borderRadius: 13,
    },

    jumpToDateContainer: {
      marginTop: 10,
      width: '100%',
    },

    headerContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      flexGrow: 1,
      paddingTop: 10,
      paddingBottom: 5,
      width: '100%',
    },

    defaultModalWindowStyle: {
      alignSelf: 'center',
      width: 510,
      height: 355,
      marginTop: 130,
      marginRight: 36,
      borderRadius: 12,
      backgroundColor: props.colors.white,
      alignItems: 'center',
    },

    modalHeader: {
      width: '100%',
      height: 54,
      borderRadius: 12,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      backgroundColor: props.colors.lightPurple,
      paddingHorizontal: 20,
      justifyContent: 'space-between',
      alignItems: 'center',
      flexDirection: 'row',
    },
    headerTextStyle: {
      fontSize: 18,
      ...props.typography.interRegular,
    },

    crossContainter: {
      height: 15,
      width: 15,
      justifyContent: 'center',
      alignItems: 'center',
    },

    crossImage: {
      height: 13,
      width: 13,
    },

    modalPhotoContainer: {
      marginTop: 40,
      flex: 1,
      borderRadius: 64,
    },

    modalPhoto: {
      width: 135,
      height: 135,
      borderRadius: 64,
    },

    inputStyle: {
      display: 'none',
    },

    addImagePen: {
      height: 13,
      width: 13,
    },

    addImagePhoto: {
      height: 13,
      width: 15,
    },

    penContainer: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      backgroundColor: props.colors.lightPurple,
      width: 36,
      height: 36,
      borderRadius: 60,
      justifyContent: 'center',
      alignItems: 'center',
    },

    buttonContainer: {
      height: 84,
      marginTop: 40,
      width: '100%',
      borderTopWidth: 1,
      borderTopColor: props.colors.extraLight,
    },

    buttonCommonStyle: {
      height: 52,
      marginTop: 16,
      width: '30%',
    },

    saveButtonTextColor: {
      fontSize: 19,
      color: props.colors.white,
      ...props.typography.mulishBold,
    },

    deleteButtonTextColor: {
      fontSize: 14,
      color: props.colors.red,
      ...props.typography.interMedium,
    },
  });
};
